import React, { useEffect } from 'react';
import { usePlanSelection } from '../../contexts/PlanSelectionContext';
import { sessionStateManager } from '../../utils/sessionStateManager';
import './PaymentSuccessSection.css';

interface PaymentSuccessSectionProps {
  className?: string;
}

const PaymentSuccessSection: React.FC<PaymentSuccessSectionProps> = ({ className = '' }) => {
  const { clearAllTravelData } = usePlanSelection();

  // Clear all travel data after successful payment
  useEffect(() => {
    console.log('PaymentSuccessSection: Payment successful - clearing all travel data');
    
    try {
      // Clear all context data (tempData, principalData, premiumAdjustments, selectedPlan, etc.)
      clearAllTravelData();
      
      // Clear all localStorage travel-related data
      localStorage.removeItem('planSelectionTempData');
      localStorage.removeItem('emailVerificationComplete');
      localStorage.removeItem('emailVerificationTempData');
      localStorage.removeItem('emailVerificationPlanType');
      localStorage.removeItem('emailVerificationShouldSetupClient');
      localStorage.removeItem('emailVerificationTimestamp');
      localStorage.removeItem('currentVerificationId');
      localStorage.removeItem('emailVerificationTempDataBackup');
      
      // Clear sessionStorage as well for complete cleanup
      sessionStorage.removeItem('emailVerificationComplete');
      sessionStorage.removeItem('emailVerificationTempData');
      sessionStorage.removeItem('emailVerificationPlanType');
      sessionStorage.removeItem('emailVerificationShouldSetupClient');
      sessionStorage.removeItem('emailVerificationTempDataBackup');
      sessionStorage.removeItem('customerPortalSessionState');
      sessionStorage.removeItem('emailVerificationTempData');
      sessionStorage.removeItem('clientInformationStepperState');
      
      // CRITICAL FIX: Clear session state manager to prevent redirect to email validation
      sessionStateManager.clearSessionState();
      
      console.log('PaymentSuccessSection: All travel data and session state cleared successfully');
    } catch (error) {
      console.error('PaymentSuccessSection: Error clearing travel data:', error);
    }
  }, [clearAllTravelData]);

  return (
    <div className={`payment-success-section ${className}`}>
      <div className="payment-success-container">
        <div className="payment-success-card">

          {/* Main Content */}
          <div className="payment-success-content">
            <h1 className="payment-success-title">
              Thank you for purchasing<br />
              Pacific Cross Travelsafe Insurance!
            </h1>

            <p className="payment-success-description">
              Your Official Confirmation of Coverage (OCC) and the<br />
              Terms and Conditions documents will be sent to the<br />
              e-mail address you provided.
            </p>

            <div className="payment-success-instructions">
              <div className="instruction-item">
                <span className="bullet">•</span>
                <span className="instruction-text">
                  If you don't receive an e-mail from Pacific<br />
                  Cross within 24 hours, feel free to reach out us at{' '}
                  <a href="mailto:traveldirect_team@pacificcross.com.ph" className="email-link">
                    traveldirect_team@pacificcross.com.ph
                  </a>
                  . We'll be happy to assist you!
                </span>
              </div>

              <div className="instruction-item">
                <span className="bullet">•</span>
                <span className="instruction-text">
                  For concerns regarding payment details and your<br />
                  credit card bill, please get in touch with your<br />
                  credit card company
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessSection;